.error-tags-total{padding:.2rem .6rem .3rem;font-size:75%;font-weight:700}.error-tag-row{display:grid;grid-template-columns:1fr auto;column-gap:1rem}.copy-error-tag-button{align-self:center}.glyphicon-copy{color:#0a0c11}
/*# sourceMappingURL=individual-field-scores.component.css.map */
